import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { storage, db } from './firebase-init';

async function compressImage(file, maxSizeMB = 1) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        const maxWidth = 1920;
        const maxHeight = 1920;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob.size > maxSizeMB * 1024 * 1024) {
              const quality = (maxSizeMB * 1024 * 1024) / blob.size;
              canvas.toBlob(
                (compressedBlob) => {
                  resolve(new File([compressedBlob], file.name, { type: 'image/jpeg' }));
                },
                'image/jpeg',
                Math.max(0.1, quality * 0.9)
              );
            } else {
              resolve(new File([blob], file.name, { type: 'image/jpeg' }));
            }
          },
          'image/jpeg',
          0.9
        );
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });
}

export async function uploadInstallerPhoto(jobId, file, photoType, installer) {
  try {
    const compressedFile = await compressImage(file);

    const timestamp = Date.now();
    const fileName = `${photoType}-${timestamp}-${installer.name.replace(/\s+/g, '')}.jpg`;
    const storagePath = `jobs/${jobId}/installer-photos/${fileName}`;
    const storageRef = ref(storage, storagePath);

    await uploadBytes(storageRef, compressedFile);

    const downloadURL = await getDownloadURL(storageRef);

    const photoData = {
      type: photoType,
      url: downloadURL,
      uploadedBy: installer.name,
      uploadedByUid: installer.uid,
      timestamp: Timestamp.now()
    };

    const jobRef = doc(db, 'jobs', jobId);
    await updateDoc(jobRef, {
      installerPhotos: arrayUnion(photoData)
    });

    return photoData;
  } catch (error) {
    console.error('❌ Error uploading photo:', error);
    throw error;
  }
}